/* eslint-disable @nx/enforce-module-boundaries */
import { Component, Input, ViewChild } from '@angular/core';
import {
  ReactiveFormsModule,
  FormGroup,
  FormControl,
} from '@angular/forms';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { ImageInputComponent } from 'admin-drivers/src/app/common/components/image-input/image-input.component';

@Component({
  selector: 't-llevo-edit-personal-form',
  standalone: true,
  imports: [
    ReactiveFormsModule,
    MatFormFieldModule,
    MatInputModule,
    MatDatepickerModule,
    ImageInputComponent,
  ],
  templateUrl: './edit-personal-form.component.html',
  styles: `
    @import '../../../../utils/styles/formGroup.scss';
    .personalForm{
      display: grid;
      grid-template-columns: repeat(2, 1fr);
      grid-template-rows: repeat(4, auto);

      & > mat-form-field:nth-child(-n + 5) {
        width: 90%;
        justify-self: center;
      }

      & > t-llevo-image-input{
        width: 90%;
        grid-row: 1 / span 4;
        grid-column: 2;
        justify-self: center;
        max-height: 300px;
      }
    }
  `
})
export class EditPersonalFormComponent {
  @ViewChild('image') imageRef!: ImageInputComponent
  @Input({required: true}) frm! : FormGroup

  private date = new Date();

  protected maxDate = new Date(
    this.date.getFullYear() - 18,
    this.date.getMonth(),
    this.date.getDate()
  );

  get name() {
    return this.frm.controls['name'];
  }

  get lastname() {
    return this.frm.controls['lastname'];
  }

  get email() {
    return this.frm.controls['email'];
  }

  get phone() {
    return this.frm.controls['phone']
  }

  get birthday() {
    return this.frm.controls['birthday'];
  }

  get dni() {
    return this.frm.controls['dni'];
  }

  get photo() {
    return this.frm.controls['photo'] as FormControl<File | null>;
  }

  loadImage(url: string) {
    this.imageRef.loadImage(url)
  }
}
